export const PER_PAGE_DEFAULT = 25;
export const START_PAGE_DEFAULT = 1;
export const LIMITS = {
  activities: {
    name: 30,
    description: 2200,
  },
  channel: {
    bio: 2200,
    categories: 3,
    tags: 10,
  },
  exercises: {
    categories: 3,
    name: 30,
    tags: 10,
  },
  classes: {
    categories: 3,
    musclegroups: 1,
    overview: 2200,
    sets: [{
      value: 1, label: 1
    }, {
      value: 2, label: 2
    }, {
      value: 3, label: 3
    }, {
      value: 4, label: 4
    }, {
      value: 5, label: 5
    }],
    tags: 10,
    title: 30,
  },
  programs: {
    categories: 3,
    musclegroups: 1,
    name: 30,
    overview: 2200,
    tags: 10,
  },
};
export const ACCEPTED_AUDIO_FORMATS = ['audio/mpeg', 'audio/mp4', 'audio/vnd.wav'];
export const ACCEPTED_VIDEO_FORMATS = ['video/mp4', 'video/quicktime', 'video/webm', 'video/x-m4v'];
export const STREAMING_STATUS = {
  PROCESSING: 'PROCESSING',
  COMPLETE: 'COMPLETE',
  TIMEOUT: 'TIMEOUT',
};
export const POLLING_INTERVAL = 10000;
export const POLLING_TIMEOUT = 300000;
export const DEFAULT_EXERCISE_VIDEO_ORIENTATION = 'portrait';
export const VIDEO_ORIENTATIONS = {
  LANDSCAPE: 'landscape',
  PORTRAIT: 'portrait',
};
